import channelPartnerHttpCommon from "../helper/channelPartnerHttpCommon";

const removeEmptyParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

export const channelPartnerGoogleLogin = (payload) =>
  channelPartnerHttpCommon.post("channel-partner-portal/google/", payload, {
    skipAuth: true,
  });

export const validateCommunityPartnerReferral = (referralReference) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/referrals/${encodeURIComponent(referralReference)}/`,
    { skipAuth: true },
  );

export const fetchChannelPartnerPortalMe = () =>
  channelPartnerHttpCommon.get("channel-partner-portal/me/");

export const fetchChannelPartnerEarningsSummary = () =>
  channelPartnerHttpCommon.get(
    "channel-partner-portal/earnings/summary/",
  );

export const fetchChannelPartnerMonthlyEarnings = () =>
  channelPartnerHttpCommon.get(
    "channel-partner-portal/earnings/monthly/",
  );

export const fetchChannelPartnerEarnings = ({
  page = 1,
  pageSize = 20,
  search = "",
  month = "",
  eventType = "",
} = {}) =>
  channelPartnerHttpCommon.get("channel-partner-portal/earnings/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
      month,
      event_type: eventType,
    }),
  });

export const fetchChannelPartnerStudentStats = () =>
  channelPartnerHttpCommon.get("channel-partner-portal/students/stats/");

export const fetchChannelPartnerStudentFilters = () =>
  channelPartnerHttpCommon.get("channel-partner-portal/students/filters/");

export const fetchChannelPartnerStudents = ({
  page = 1,
  pageSize = 20,
  search = "",
  filters = {},
}) =>
  channelPartnerHttpCommon.get("channel-partner-portal/students/", {
    params: removeEmptyParams({
      page,
      page_size: pageSize,
      search,
      city: filters.city || "",
      board: filters.board || "",
      school: filters.school || "",
      student_class: filters.student_class || "",
    }),
  });

export const fetchChannelPartnerCounsellorStats = () =>
  channelPartnerHttpCommon.get("channel-partner-portal/counsellors/stats/");

export const fetchChannelPartnerCounsellors = ({
  page = 1,
  pageSize = 20,
  search = "",
}) =>
  channelPartnerHttpCommon.get("channel-partner-portal/counsellors/", {
    params: removeEmptyParams({ page, page_size: pageSize, search }),
  });

export const createChannelPartnerCounsellor = (payload) =>
  channelPartnerHttpCommon.post(
    "channel-partner-portal/counsellors/",
    payload,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

export const fetchChannelPartnerCounsellor = (counsellorId) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/counsellors/${counsellorId}/`,
  );

export const updateChannelPartnerCounsellor = (counsellorId, payload) =>
  channelPartnerHttpCommon.patch(
    `channel-partner-portal/counsellors/${counsellorId}/`,
    payload,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

export const deleteChannelPartnerCounsellor = (counsellorId) =>
  channelPartnerHttpCommon.delete(
    `channel-partner-portal/counsellors/${counsellorId}/`,
  );

export const fetchChannelPartnerCounsellorWorkStats = (counsellorId) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/counsellors/${counsellorId}/work-stats/`,
  );

export const fetchChannelPartnerCounsellorStudents = (
  counsellorId,
  { page = 1, pageSize = 20, search = "" } = {},
) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/counsellors/${counsellorId}/students/`,
    {
      params: removeEmptyParams({ page, page_size: pageSize, search }),
    },
  );

export const updateChannelPartnerCounsellorCompletion = (
  counsellorId,
  appointmentId,
  completionStatus,
) =>
  channelPartnerHttpCommon.patch(
    (
      `channel-partner-portal/counsellors/${counsellorId}/appointments/`
      + `${appointmentId}/completion/`
    ),
    { completion_status: completionStatus },
  );

export const fetchChannelPartnerSkillProviderStats = () =>
  channelPartnerHttpCommon.get("channel-partner-portal/skill-providers/stats/");

export const fetchChannelPartnerSkillProviders = ({
  page = 1,
  pageSize = 20,
  search = "",
}) =>
  channelPartnerHttpCommon.get("channel-partner-portal/skill-providers/", {
    params: removeEmptyParams({ page, page_size: pageSize, search }),
  });

export const createChannelPartnerSkillProvider = (payload) =>
  channelPartnerHttpCommon.post(
    "channel-partner-portal/skill-providers/",
    payload,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

export const fetchChannelPartnerSkillProvider = (skillProviderId) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/skill-providers/${skillProviderId}/`,
  );

export const updateChannelPartnerSkillProvider = (skillProviderId, payload) =>
  channelPartnerHttpCommon.patch(
    `channel-partner-portal/skill-providers/${skillProviderId}/`,
    payload,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

export const deleteChannelPartnerSkillProvider = (skillProviderId) =>
  channelPartnerHttpCommon.delete(
    `channel-partner-portal/skill-providers/${skillProviderId}/`,
  );

export const fetchChannelPartnerSkillProviderWorkStats = (skillProviderId) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/skill-providers/${skillProviderId}/work-stats/`,
  );

export const fetchChannelPartnerSkillProviderStudents = (
  skillProviderId,
  { page = 1, pageSize = 20, search = "" } = {},
) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/skill-providers/${skillProviderId}/students/`,
    {
      params: removeEmptyParams({ page, page_size: pageSize, search }),
    },
  );

export const fetchChannelPartnerCommunityPartners = ({
  page = 1,
  pageSize = 100,
  search = "",
} = {}) =>
  channelPartnerHttpCommon.get("channel-partner-portal/community-partners/", {
    params: removeEmptyParams({ page, page_size: pageSize, search }),
  });

export const fetchChannelPartnerCommunityPartnersStats = () =>
  channelPartnerHttpCommon.get(
    "channel-partner-portal/community-partners/stats/",
  );

export const createChannelPartnerCommunityPartner = (payload) =>
  channelPartnerHttpCommon.post(
    "channel-partner-portal/community-partners/",
    payload,
  );

export const updateChannelPartnerCommunityPartner = (
  communityPartnerId,
  payload,
) =>
  channelPartnerHttpCommon.patch(
    `channel-partner-portal/community-partners/${communityPartnerId}/`,
    payload,
  );

export const deleteChannelPartnerCommunityPartner = (communityPartnerId) =>
  channelPartnerHttpCommon.delete(
    `channel-partner-portal/community-partners/${communityPartnerId}/`,
  );

export const fetchChannelPartnerCommunityPartnerStats = (communityPartnerId) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/community-partners/${communityPartnerId}/stats/`,
  );

export const fetchChannelPartnerCommunityPartnerStudents = (
  communityPartnerId,
  { page = 1, pageSize = 20, search = "" } = {},
) =>
  channelPartnerHttpCommon.get(
    `channel-partner-portal/community-partners/${communityPartnerId}/students/`,
    {
      params: removeEmptyParams({ page, page_size: pageSize, search }),
    },
  );
